import React from "react";
import { Button, Dropdown } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useStockCheckModel } from "../stockCheckModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useStockCheckDetailModel, IMaterialDetailModel } from "./details/stockCheckDetailsModel";
import { AuthButton } from "@/components/auth/AuthButton";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { ResourcesAuthBtn } from "@/types/ResourcesAuthEnum";
import { mianCode } from "@/utils/constants";
import { DownOutlined } from "@ant-design/icons";
export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { drawerVisible, setDrawerVisible, selectedRow, selectedRowKeys, invalidateData,listExport } = useStockCheckModel();
    const { setDetailDataSource, setDetailEditForm } = useStockCheckDetailModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行编辑", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for editing."], type: "warning" });
            return;
        }
        let supplierEditKey = "4-2-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                // title: "库存盘点跳转详情",
                title:Locale["Jump to the detail page of stocktaking doc."],
                type: "warning",
                // text: "您还有库存盘点单详情未保存，是否跳转",
                text:Locale["The detail page of stocktaking doc has not been saved. Do you still want to jump?"],
                // okText: "跳转未保存页",
                okText: Locale["Jump to the unsaved page"],
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                // cancelText: "打开新页签",
                cancelText: Locale["Open a new page"],
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRowKeys[0] as string, mode: "edit" });
                    setDetailDataSource([])
                    setDetailEditForm({})
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行查看", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data to view."], type: "warning" });
            return;
        }
        let supplierEditKey = "4-2-3";
        replaceNav(
            selectedNavId,
            "4-2-3",
            { id: selectedRowKeys[0], mode: "look", },
            true
        );
    }
    const cancellation = async () => {
        console.log(selectedRow)
        if (selectedRowKeys.length !== 1) {
            // globalPrompt("message", { text: "请选择单条数据进行作废", type: "warning" });
            globalPrompt("message", { text: Locale["Please select a single piece of data for cancellation."], type: "warning" });

            return;
        }
        let val: string = ""
        globalPrompt("modal", {
            // title: "盘库单作废",
            title:Locale["Cancel the stocktaking doc."],
            type: "error",
            text: "",
            // okText: "确定",
            okText: Locale["Yes No"],
            onOk: () => {
                let obj = {
                    id: selectedRow.id,
                    stocktakingCode: selectedRow.stocktakingCode
                }
                invalidateData(obj)
            },
            // cancelText: "取消",
            cancelText: Locale["cancel"],
            onCancel: () => {
            }
        })
    }
    const onExport = () => {
        listExport().then()
    }
    const action = <>
        <AuthButton
            // resCode="StocktakingAdd"
            resCode={ResourcesAuthBtn[mianCode]["StocktakingAdd"]}  
            onClick={() => addNav("4-2-1", { id: "", mode: "add" })}
            // name="新增"
            name={Locale["Add"]}
        />
        <AuthButton
            // resCode="StocktakingEdit"
            resCode={ResourcesAuthBtn[mianCode]["StocktakingEdit"]}  
            onClick={onEdit}
            // name="编辑"
            name={Locale["Edit"]}
        />
        <AuthButton
            // resCode="StocktakingView"
            resCode={ResourcesAuthBtn[mianCode]["StocktakingView"]}
            onClick={onLook}
            // name="查看"
            name={Locale["View"]}
        />
        <AuthButton
            // resCode="StocktakingCancel"
            resCode={ResourcesAuthBtn[mianCode]["StocktakingCancel"]}
            onClick={cancellation}
            // name="作废"
            name={Locale["Cancel"]}
        />
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onExport}
        >{Locale["export"]}</Button>


        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => addNav("4-2-1", { id: "", mode: "add" })}
        >新增</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onLook}
        >查看</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={cancellation}
        >作废</Button> */}
    </>;

    return (
        <YhBox title={action} >
            <DataTable />
        </YhBox>
    )
}